<template>
  <section class="xb-section-container">
    <h2 class="underline">PII Uploader</h2>

    <b-message class="xb-message" type="is-info" has-icon>
      You may upload the PII records
      <a
        class="xb-link"
        href="/aceas/PII-management/PII-information-uploader"
      >here</a>
    </b-message>
  </section>
</template>

<script>
export default {};
</script>

<style>
</style>